import { getWarehouses, selectWarehouses, selectWarehouseStatus } from 'containers/Warehouses/warehousesSlice'
import { selectUserFavorites, selectUserId } from 'containers/Login/loginSlice'
import { addNotification } from 'containers/Notifications/notificationsSlice'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import { useHistory } from 'react-router-dom'
import MagNumber from 'components/MagNumber'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useReduxDispatch } from 'store'
import Error from 'components/Error'
import { POST } from 'rest/request'
import { POPUPS } from './Popups'
import { api } from 'rest/urls'

const Favorite = () => {
  const clientId = useSelector(selectUserId)
  const status = useSelector(selectWarehouseStatus)
  const favorites = useSelector(selectUserFavorites)
  const warehouses = useSelector(selectWarehouses)
  const [isLoading, setLoading] = useState({
    action: false,
    warehouses: status === 'failed' || status === 'idle'
  })

  const { push } = useHistory()
  const dispatch = useReduxDispatch()
  const { t } = useTranslation('dashboard')
  const runAction = async ({ method, payload, url, type }) => {
    if (type !== 'request' && type !== 'redirect') return
    if (type === 'redirect') {
      push(url)
      return
    }
    if (isLoading.action || method !== 'POST') return
    setLoading(prev => ({ ...prev, action: true }))

    try {
      const body = url === 'genericAction' ? { payload } : payload
      const response = await POST(`${api}${url}`, { body })
      if (response?.result === 'ok') console.log(response)
      setLoading(prev => ({ ...prev, action: false }))
    } catch (error) {
      setLoading(prev => ({ ...prev, action: false }))
    }
  }

  useEffect(() => {
    if (clientId && isLoading.warehouses) {
      dispatch(getWarehouses(clientId)).then(() => {
        setLoading(prev => ({ ...prev, warehouses: false }))
      })
    }
  }, [clientId, dispatch, isLoading.warehouses])

  return (
    <div className='dashboard__favorite'>
      {favorites && favorites.length > 0
        ? favorites.map(({ id, related }) => <div
          key={id}
          className='favorite__card'
          onClick={() => {
            if (isLoading.warehouses) {
              dispatch(addNotification({ message: 'Trwa ładowanie - proszę czekać!', type: 'info' }))
            } else if (related?.object === 'Warehouse' && related?.id) {
              if (warehouses.find(warehouse => warehouse.objectId === related.id)) {
                push(`/warehouses/${related.id}`)
              } else {
                push(window.location.pathname, LOCATION_STATES.popup({ type: POPUPS.removeFavorite, relatedId: related?.id }))
              }
            }
          }}>
          <div className='favorite__card__head'>
            <div className='badge'>
              <i className='icon icon--location-500'></i>
              <span>{related.address}</span>
            </div>
            <div className='options'>
              <i className='icon icon--dots'></i>
            </div>
          </div>
          <div className='favorite__card__body'>
            <MagNumber number={related.number} isLight={true} />
          </div>
          <div className='favorite__card__footer'>
            {Object.values(related?.actions).map(({ open }, idx) => <div
              key={idx}
              className='status'
              onClick={e => {
                e.stopPropagation()
                if (!open) return
                runAction(open)
              }}>
              {open?.text}
            </div>)}
          </div>
        </div>)
        : <Error
          staticPos
          text={t('noFavorites')}
        />}
    </div>
  )
}

export default Favorite